// @ts-nocheck
/* eslint-disable react/prop-types */
import { Backdrop, CircularProgress, Typography } from "@mui/material";
import styled from "@emotion/styled";

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: "#fff",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  height: "100%",
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "14px",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: 0,
  left: 0,
  borderRadius: "12px",
}));

export default function LoadingOverlay({ open, message }) {
  return (
    <StyledBackdrop open={open}>
      <CircularProgress color="secondary" />
      {message ? (
        <Typography sx={{ color: "#fff", fontWeight: 600, textAlign: "center" }}>
          {message}
        </Typography>
      ) : null}
    </StyledBackdrop>
  );
}
